import React from "react";
import { CALENDAR_TYPES, EMAIL_ENTITY_TYPE } from "@miplatform/constants";
import {
  IAttemptListItemResponseForWorkOrder,
  IAttemptListResponse,
} from "@miplatform/types";
import { EmailActivityPreviewModal } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { useCalendarContext } from "../../providers";
import { OrdersEmailDrawer } from "../Orders/OrdersEmailDrawer/OrdersEmailDrawer";
import { useOrdersContext } from "../Orders/OrdersProvider";
import { HoldsListCalendar } from "./HoldsListCalendar";
import { KanbanCalendar } from "./KanbanCalendar";
import { NHCPriorityScheduler } from "./NHCPriorityScheduler/NHCPriorityScheduler";
import { SingleDayScheduler } from "./SingleDayScheduler";

export const CalendarRenderer: React.FC<CalendarRendererProps> = ({
  setSelectedOrder,
  orderReasons,
}) => {
  const {
    emailDrawer,
    emailPreview,
    handleEmailDrawerClose,
    handleEmailPreviewModalClose,
  } = useOrdersContext();

  const { date, refreshData, calendarConfig, calendarSet } =
    useCalendarContext();

  if (!calendarConfig) {
    return null;
  }

  const renderCalendar = () => {
    switch (calendarConfig.calendarType) {
      case CALENDAR_TYPES.SCHEDULER:
        return (
          <SingleDayScheduler
            calendar={calendarConfig}
            date={date}
            calendarSet={calendarSet}
          />
        );
      case CALENDAR_TYPES.PRIORITY_SCHEDULER:
        return <NHCPriorityScheduler />;
      case CALENDAR_TYPES.KANBAN:
        return (
          <KanbanCalendar
            setSelectedOrder={setSelectedOrder}
            orderReasons={orderReasons}
          />
        );
      case CALENDAR_TYPES.HOLDS_LIST:
        return (
          <HoldsListCalendar
            onRefresh={refreshData}
            orderReasons={orderReasons}
          />
        );
      default:
        return <Box>Unknown calendar type: {calendarConfig.calendarType}</Box>;
    }
  };

  return (
    <>
      {renderCalendar()}
      {emailDrawer && (
        <OrdersEmailDrawer
          // @ts-expect-error fixing this error will require to change the OrdersEmailDrawer to typescript
          open={emailDrawer.isOpen}
          entity={emailDrawer.order}
          entityType={EMAIL_ENTITY_TYPE.ORDER}
          templateType={emailDrawer.templateType}
          onClose={handleEmailDrawerClose}
        />
      )}
      {emailPreview && (
        <EmailActivityPreviewModal
          isEmailModalOpen
          activity={emailPreview}
          details={emailPreview}
          closeEmailModal={handleEmailPreviewModalClose}
        />
      )}
    </>
  );
};

interface CalendarRendererProps {
  setSelectedOrder: (
    order:
      | IAttemptListResponse
      | IAttemptListItemResponseForWorkOrder
      | undefined
  ) => void;
  orderReasons: {
    holdReasons: { value: string; label: string }[];
    rescheduleReasons: { value: string; label: string }[];
  };
}
